import { Title } from '@components/styled/Title.styled';
import styled from 'styled-components';
import { InputRow } from './InputRow.styled';

export const AddressGroup = styled(InputRow)`
    width: 100%;
    display: flex;

    ${Title} {
        color: inherit;
    }
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;
